
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Irrfahrt oder Vorzeigebeispiel? Schwedens Sonderweg im Umgang mit der Covid-19-Pandemie polarisiert. Einerseits hat der Verzicht der Regierung auf Zwangs`}{`­`}{`mass`}{`­`}{`nahmen bei der Eindämmung von Sars-CoV-2 unmittelbare Auswirkungen auf den Verlauf der Pandemie: eine hohe Anzahl Todes`}{`­`}{`fälle und eine weiterhin nicht sinkende Rate der Neu`}{`­`}{`infektionen. Anderseits wirft der sanfte Kurs Schwedens die Frage auf, ob  die weniger radikalen Massnahmen Schwedens zu einer mittel`}{`­`}{`fristig besseren wirt`}{`­`}{`schaftlichen Entwicklung des Landes führen.`}</p>
    <p>{`Durch den Weg der schrittweisen Lockerung des Lockdowns seit Ende April schwenkt die Schweiz zusehends auf einen Kurs ein, der dem schwedischen sehr ähnlich ist. So sieht es die `}<a parentName="p" {...{
        "href": "https://ncs-tf.ch/de/"
      }}>{`Science Task Force`}</a>{` des Bundes, die dem Vergleich der Schweiz mit Schweden einen `}<a parentName="p" {...{
        "href": "https://ncs-tf.ch/de/policy-briefs/comparison-of-sweden-and-switzerland-2"
      }}>{`Bericht`}</a>{` widmete.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;